import { createFetcherReducer } from '../utils';
import {
  LOADING_CITING_ARTICLES,
  RECEIVED_CITING_ARTICLES,
  RECEIVED_CITING_ARTICLES_FAILED,
} from '../../actions/types';

export default createFetcherReducer(
  LOADING_CITING_ARTICLES,
  RECEIVED_CITING_ARTICLES,
  RECEIVED_CITING_ARTICLES_FAILED,
);
